
import React from 'react';
import { Cat, RotateCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Task } from '@/types/task';
import { useAuth } from '@/contexts/AuthContext';

interface CompletionStatusProps {
  isAdmin?: boolean;
  task: Task;
  onReactivate?: (task: Task) => void;
}

export const CompletionStatus = ({ isAdmin, task, onReactivate }: CompletionStatusProps) => {
  const { user } = useAuth();
  const isUserAdmin = user?.role === 'admin';

  const handleReactivate = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent the event from bubbling up to the card
    if (onReactivate && isUserAdmin) {
      onReactivate(task);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <Cat className="h-5 w-5 text-cat-primary animate-bounce" />
        <span className="text-sm text-cat-primary">Completed!</span>
      </div>
      
      {isUserAdmin && onReactivate && (
        <Button
          variant="ghost"
          size="icon"
          onClick={handleReactivate}
          className="h-6 w-6 text-gray-500 hover:text-cat-primary"
        >
          <RotateCw className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};
